import { FC } from 'react';

import bootstrapPage, { BootstrapPageProps } from '../HOCs/bootstrapPage';
import MetaHead from '../components/MetaHead';
import Layout from '../components/layouts/Layout';

const htmlCode = `<div name="termly-embed" data-id="4c0bfc2c-440b-435f-a991-3f348d6bc8b6" data-type="iframe"></div>
<script type="text/javascript">(function(d, s, id) {
  var js, tjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = "https://app.termly.io/embed-policy.min.js";
  tjs.parentNode.insertBefore(js, tjs);
}(document, 'script', 'termly-jssdk'));</script>`;

const TermsUsePage: FC<BootstrapPageProps> = () => (
  <>
    <MetaHead 
      title="Terms of Use | Wave.video"
      description="This page explains the terms by which you may use our online services and website."
    />
    <Layout navigationVariant="white" mainVariant="contain">
      <div dangerouslySetInnerHTML={{__html: htmlCode}}>
      </div>
    </Layout>
  </>
);

export default bootstrapPage(TermsUsePage);
